export default {"src":"/_next/static/media/bell.aa888a78.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};